// @flow
import * as React from "react"
import {FormattedMessage} from "react-intl"

export function intlMessages(prefix: string) {
  return (props: {id: string}) => (
    <FormattedMessage {...props} id={prefix + "." + props.id} />
  )
}



// WEBPACK FOOTER //
// ./src/common/intlMessages.js